import type { RouteObject } from 'react-router-dom'

import type { NavItem } from '@/app/registry'

import { CharacterPage } from './CharacterPage'

export const routes: RouteObject[] = [{ path: '/character', element: <CharacterPage /> }]

export const nav: NavItem[] = [{ path: '/character', label: 'Персонаж', icon: 'character', mobile: 'more', order: 45 }]
